"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .config(function ($stateProvider, $urlRouterProvider) {
    $stateProvider.state("main.promotionrequest", {
      url: "promotionrequest",
      resolve: {
        list: [
          "$stateParams",
          "PromotionRequest",
          function ($stateParams, PromotionRequest) {
            return PromotionRequest.list().$promise;
          },
        ],
        status: [
          "Status",
          function (Status) {
            return Status.listIds({ moduleId: window.enumerators.modules.Acoes })
              .$promise;
          },
        ],
        workflowPendingDaysLate: [
          "$stateParams",
          "Internal",
          function ($stateParams, Internal) {
            return Internal.parameters({ entry: "WorkflowPendingDaysLate" })
              .$promise;
          },
        ],
      },
      views: {
        main: {
          templateUrl:
            "/modules/SWFlow/promotionrequest/views/promotionrequest.list.html",
          controller: "promotionrequestListCtrl",
          controllerAs: "vm",
        },
      },
    });

    $stateProvider.state("main.promotionrequest-edit", {
      url: "promotionrequest/:id",
      resolve: {
        model: [
          "$stateParams",
          "PromotionRequest",
          function ($stateParams, PromotionRequest) {
            if ($stateParams.id) {
              return PromotionRequest.get({ id: $stateParams.id }).$promise;
            }

            return {};
          },
        ],
        promotionRequestTypes: [
          "PromotionRequestType",
          "$stateParams",
          function (PromotionRequestType, $stateParams) {
            if ($stateParams.id) {
              return PromotionRequestType.listByPromotionRequest({
                id: $stateParams.id,
              }).$promise;
            }

            return PromotionRequestType.list({}).$promise;
          },
        ],
        productSegments: [
          "ProductSegment",
          function (ProductSegment) {
            return ProductSegment.listIds().$promise;
          },
        ],
        goals: [
          "Goal",
          function (Goal) {
            return Goal.listIds().$promise;
          },
        ],
        targetAudiences: [
          "TargetAudience",
          function (TargetAudience) {
            //return TargetAudience.listIds().$promise;
            return TargetAudience.list({ page: 1, pageSize: 1000 }).$promise;
          },
        ],
        states: [
          "Internal",
          function (Internal) {
            return Internal.states().$promise;
          },
        ],
        workflowApprovals: [
          "$stateParams",
          "WorkflowApproval",
          function ($stateParams, WorkflowApproval) {
            var id = $stateParams.id ? $stateParams.id : 0;
            return WorkflowApproval.list({
              page: 1,
              pageSize: 1000,
              promotionRequestId: id,
            }).$promise;
          },
        ],
        revenues: [
          "$stateParams",
          "PromotionRequestRevenue",
          function ($stateParams, PromotionRequestRevenue) {
            var id = $stateParams.id ? $stateParams.id : 0;
            return PromotionRequestRevenue.list({ promotionRequestId: id })
              .$promise;
          },
        ],
        attachmentTypes: [
          "$stateParams",
          "Attachment",
          function ($stateParams, Attachment) {
            var id = $stateParams.id ? $stateParams.id : 0;
            return Attachment.list({
              promotionRequestId: id,
              moduleId: window.enumerators.modules.Acoes,
            }).$promise;
          },
        ],
        allowedFileExtensions: [
          "$stateParams",
          "Internal",
          function ($stateParams, Internal) {
            return Internal.parameters({ entry: "AllowedFileExtensions" })
              .$promise;
          },
        ],
        maxAllowedFileSize: [
          "$stateParams",
          "Internal",
          function ($stateParams, Internal) {
            return Internal.parameters({ entry: "MaxAllowedFileSize" })
              .$promise;
          },
        ],
      },
      views: {
        main: {
          templateUrl:
            "/modules/SWFlow/promotionrequest/views/promotionrequest.edit.html",
          controller: "promotionrequestEditCtrl",
          controllerAs: "vm",
        },
      },
    });
  });
